import { Component, OnInit, OnDestroy, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FuenteDinamicaComponent } from 'src/app/pages/data-maintenance/fuente-dinamica/fuente-dinamica.component'; // Asegúrate de la ruta correcta
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { FuenteDinamicaService } from 'src/app/services/shared/fuente-dinamica/fuente-dinamica.service';
import { SessionService } from 'src/app/services/shared/session/session.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { MenuService } from 'src/app/services/shared/menu/menu.service';
import { Menu } from 'src/app/entities/shared/Menu';
import { Country } from "src/app/entities/shared/Country";
import { Icountry } from 'src/app/entities/shared/Country';
import { User } from 'src/app/entities/shared/User';
import COUNTRIES from "src/assets/data/shared/COUNTRIES.json";
import { environment } from 'src/environments/environment';
import { Subject, switchMap, takeUntil, tap, catchError } from 'rxjs';
import { of } from 'rxjs';

@Component({
    selector: 'app-rds-token-pingid',
    templateUrl: './rds-token-pingid.component.html',
    standalone: false
})
export class RdsTokenPingidComponent implements OnInit, OnDestroy {
  countries: Icountry[] = COUNTRIES;
  private destroy$ = new Subject<void>();
  private hasValidPortalCode = false;
  private isRedirectingToPortal = false;
  private redirectTimeoutId: number | null = null;
  redirectNoticeMessage: string = '';
  showRedirectNotice: boolean = false;

  region: string | null = null;
  domain: string | null = null;
  subDomain: string | null = null;
  primaryKey: string | null = null;
  rdsAccessToken: string | null = null;
  userCode: string = "";
  userName: string = "";
  userEmail: string = "";
  mostrarFuenteDinamica = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private localStorageService: LocalStorageService,
    private fuenteDinamicaService: FuenteDinamicaService,
    private sessionService: SessionService,
    private sharedService: SharedService,
    private menuService: MenuService,
  ) {
    this.localStorageService.setIsExternoRDS = true;
    this.getInitConfigVault();
  }

  getInitConfigVault() {
    const url = window.location.host;

    this.route.queryParams.pipe(
      takeUntil(this.destroy$),
      tap(queryParams => {
        this.hasValidPortalCode = false;
        const codeUrlRaw = queryParams['code'];
        if (!codeUrlRaw) {
          return;
        }

        const decodedCode = this.decodePortalCode(codeUrlRaw);
        if (!decodedCode) {
          console.error('Error en getInitConfigVault: no se pudo decodificar code');
          return;
        }

        const codeUrlDecodeObj = decodedCode.split('@@@');

        if (codeUrlDecodeObj.length !== 3 && codeUrlDecodeObj.length !== 4) {
          console.error('Error en getInitConfigVault: formato de code inválido');
          return;
        }

        if (codeUrlDecodeObj.length === 4) {
          this.rdsAccessToken = codeUrlDecodeObj[1];
          this.userName = codeUrlDecodeObj[2];
          this.userCode = codeUrlDecodeObj[3];
        } else {
          this.rdsAccessToken = null;
          this.userName = codeUrlDecodeObj[1];
          this.userCode = codeUrlDecodeObj[2];
        }

        this.hasValidPortalCode = true;

        this.userEmail = this.userCode + "@equifax.com";

        if (!this.rdsAccessToken) {
          // Compatibilidad con contrato legacy (3 campos sin access_token).
          console.warn('getInitConfigVault: access_token ausente en code, se continúa con flujo legacy');
        } else {
          this.persistReceivedAccessToken(this.rdsAccessToken);
        }
      }),
      switchMap(() => {
        if (!this.hasValidPortalCode) {
          return of(null);
        }
        if (!this.rdsAccessToken) {
          return of(null);
        }
        return this.sharedService.getConfigInit(url);
      }),
      tap((response) => {
        if (!response) {
          return;
        }
        this.localStorageService.configInit = response;
        this.localStorageService.setNiveles = response['F_PERMISSION_ALL_ROLES'];
      }),
      switchMap(() => this.hasValidPortalCode ? this.paramsRds() : of(null)),
      catchError(err => {
        if (this.isUnauthorizedError(err)) {
          return this.handleUnauthorizedAndRedirect('Sesion invalida o expirada al inicializar RDS desde Portal', err);
        }
        console.error('Error en getInitConfigVault:', err);
        return of(null);
      })
    ).subscribe();
  }

  private isUnauthorizedError(error: any): boolean {
    const status = Number(error?.status);
    return status === 401 || status === 403;
  }

  private clearAuthStorage(): void {
    localStorage.removeItem('tokenAuth');
    localStorage.removeItem('access_token');
    localStorage.removeItem('tokenObj');
    localStorage.removeItem('idToken');
    localStorage.removeItem('loginStatus');
  }

  private handleUnauthorizedAndRedirect(context: string, error: any) {
    console.error(context, error);

    if (this.isRedirectingToPortal) {
      return of(null);
    }

    this.isRedirectingToPortal = true;
    this.clearAuthStorage();

    this.redirectNoticeMessage = 'Tu sesión con Portal expiró o no es válida. Serás redirigido para iniciar sesión nuevamente.';
    this.showRedirectNotice = true;

    this.redirectTimeoutId = window.setTimeout(() => {
      window.location.assign(environment.F_OKTA_PORTAL_URL);
    }, 1800);

    return of(null);
  }

  private decodePortalCode(rawCode: string): string | null {
    let normalizedCode = rawCode;

    try {
      // Si el code viene percent-encoded (%3D, etc.), lo decodificamos primero.
      normalizedCode = decodeURIComponent(normalizedCode);
    } catch (_error) {
      // Si ya viene decodificado, continuamos sin cortar el flujo.
    }

    // Algunos proveedores transforman '+' en espacios al pasar query params.
    normalizedCode = normalizedCode.replace(/ /g, '+');

    // Soporte defensivo por si el proveedor envía base64url.
    normalizedCode = normalizedCode.replace(/-/g, '+').replace(/_/g, '/');

    // Asegurar padding válido para atob.
    const missingPadding = normalizedCode.length % 4;
    if (missingPadding > 0) {
      normalizedCode = normalizedCode.padEnd(normalizedCode.length + (4 - missingPadding), '=');
    }

    try {
      return atob(normalizedCode);
    } catch (error) {
      console.error('Error decodificando code de portal en atob:', error);
      return null;
    }
  }

  private persistReceivedAccessToken(accessToken: string): void {
    localStorage.removeItem('tokenAuth');
    localStorage.setItem('tokenAuth', accessToken);
    localStorage.removeItem('access_token');
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('tokenObj', JSON.stringify({
      access_token: accessToken,
      token_type: 'Bearer',
    }));
    localStorage.setItem('loginStatus', 'Ok');
  }

  ngOnInit(): void {
  }

  private normalizeRdsCountryCode(code: string): string {
    const normalized = (code || '').toLocaleLowerCase();
    return normalized === 'do' ? 'rd' : normalized;
  }

  obtenerFuenteDesdeRuta() {
    return of(null);
  }

  paramsRds() {
    return this.route.paramMap.pipe(
      takeUntil(this.destroy$),
      tap(params => {
        let nameDominios = {
          'ar': 'RDS_ARGENTINA',
          'py': 'RDS_PARAGUAY',
          'cl': 'RDS_CHILE',
          'do': 'RDS_REPUBLICA_DOMINICANA',
          'rd': 'RDS_REPUBLICA_DOMINICANA',
          'pe': 'RDS_PERU',
          'cr': 'RDS_COSTA_RICA',
          'uy': 'RDS_URUGUAY',
          'ec': 'RDS_ECUADOR'
        };
        const rawRegionParam = (params.get('region') || '').toLocaleLowerCase();
        const rawDomainParam = (params.get('domain') || '').toLocaleLowerCase();
        const regionParam = this.normalizeRdsCountryCode(rawRegionParam || rawDomainParam);
        const domainParam = this.normalizeRdsCountryCode(rawDomainParam || rawRegionParam);
        const subDomainParam = (params.get('subDomain') || '').toUpperCase();
        const primaryKeyParam = params.get('primaryKey') || '';

        this.region = regionParam || null;
        this.domain = nameDominios[domainParam] || nameDominios[regionParam] || null;
        this.subDomain = subDomainParam || null;

        this.primaryKey = primaryKeyParam || null;
        if (this.primaryKey) {
          this.localStorageService.setMatchkeySelected = this.primaryKey;
        }

        if (!this.region || !this.domain || !this.subDomain) {
          console.error('Error en paramsRds: parámetros inválidos para ruta RDS', {
            region: rawRegionParam,
            domain: rawDomainParam,
            subDomain: subDomainParam,
          });
          return;
        }
        console.log('region:', this.region);
        console.log('domain:', this.domain);
        console.log('subDomain:', this.subDomain);
        console.log('primaryKey:', this.primaryKey);

        this.emuTokenPingIdRds();

        let permisos = [ // Mock RDS
          {
            "country": this.region.toUpperCase(),
            "ambiente": "NPE",
            "roles": "ADMIN"
          },
          {
            "country": this.region.toUpperCase(),
            "ambiente": "UAT",
            "roles": "ADMIN"
          },
          {
            "country": this.region.toUpperCase(),
            "ambiente": "PRD",
            "roles": "ADMIN"
          },
        ];

        let countriesLogin: any[] = permisos.map(function (data: any) {
          return COUNTRIES.find(
            (element) => element.code.toUpperCase() === data.country.toUpperCase()
          );
        }).filter((country) => !!country);

        let inicializaUser: User = this.sharedService.inicializaUser();
        console.log('countriesLoginRds', countriesLogin);
        console.log('permisosRDS', permisos);
        inicializaUser.setEntitlement(permisos);

        console.log('inicializaUser', inicializaUser);
        this.localStorageService.setDataLogin = inicializaUser;

        sessionStorage.setItem("rolesUsuario", JSON.stringify(permisos));
        sessionStorage.setItem("dataCountries", JSON.stringify(countriesLogin));

        let datDataCountries = this.getListCountry(countriesLogin);
        console.log('datDataCountries', datDataCountries);
        this.localStorageService.setDataCountries = datDataCountries;

        console.log('this.listCountry', this.listCountry);
        if (this.listCountry?.length === 1) {
          const countryInstance = new Country();
          Object.assign(countryInstance, this.listCountry[0]);
          this.selectCountry(countryInstance);
        } else {
          const countryFound = COUNTRIES.find((country) => (country.code || '').toUpperCase() === this.region?.toUpperCase());
          if (countryFound) {
            const countryInstance = new Country();
            Object.assign(countryInstance, countryFound);
            this.selectCountry(countryInstance);
          }
        }

        let datDataSourceSelected = Object.assign(
          new Menu(),
          {
            periods: false,
            periodsType: "",
            domaine: this.domain,
            domainJO: this.domain,
            subDomainJO: this.subDomain,
          });
        console.log('datDataSourceSelected', datDataSourceSelected);
        this.localStorageService.setDataSourceSelected = datDataSourceSelected;
      }),
      switchMap(() => this.getMenu())
    );
  }

  emuTokenPingIdRds() { // Mock RDS
    const regionValue = this.region || '';
    this.localStorageService.setCountryString = regionValue;
    let emuTokenPingIdJsonRds = {
      "sub": this.userCode,
      "aud": "",
      "jti": "",
      "iss": "", // https://fedssoqa.equifax.com
      "iat": 0,
      "exp": 0,
      "acr": "",
      "auth_time": 0,
      "firstName": this.userName,
      "lastName": "",
      "mail": this.userEmail,
      "groups": [
        "CN=" + regionValue.toLowerCase() + "-rds_npe_admin,OU=rds,OU=rds,OU=rds,DC=rds,DC=rds,DC=rds", // -datamaintenance_npe_admin,OU=datafabric,OU=appgroups,OU=accessmgmnt,DC=eis,DC=equifax,DC=com
        "CN=" + regionValue.toLowerCase() + "-rds_uat_admin,OU=rds,OU=rds,OU=rds,DC=rds,DC=rds,DC=rds",
        "CN=" + regionValue.toLowerCase() + "-rds_prd_admin,OU=rds,OU=rds,OU=rds,DC=rds,DC=rds,DC=rds"
      ],
      "pi.sri": "",
      "s_hash": ""
    };

    let emuPingIdIdTokenRds = "eyJhbGciOiJSUzI1NiIsImtpZCI6IiJ9." + btoa(JSON.stringify(emuTokenPingIdJsonRds)) + ".JE5Q";
    // let emuPingIdTokenObjRds = { access_token: "", expires_in: 99999, id_token: emuPingIdIdTokenRds, refresh_token: "", scope: "", token_type: "" };
    console.log('idToken RDS', emuPingIdIdTokenRds);
    localStorage.setItem('idToken', emuPingIdIdTokenRds);

    let tokenObj = localStorage.getItem('tokenObj');
    let tokenObjJson = tokenObj ? JSON.parse(tokenObj) : {};
    tokenObjJson.id_token = emuPingIdIdTokenRds;
    localStorage.setItem('tokenObj', JSON.stringify(tokenObjJson));
    localStorage.setItem('loginStatus', 'Ok');

  }

  cargarFuenteDinamica() {
    // 1. Obtener el ComponentFactory para FuenteDinamicaComponent
    const factory = this.componentFactoryResolver.resolveComponentFactory(FuenteDinamicaComponent);

    // 2. Limpiar cualquier vista existente en el contenedor
    this.viewContainerRef.clear();

    // 3. Crear una instancia del componente y adjuntarla al contenedor
    const componentRef = this.viewContainerRef.createComponent(factory);

    // 4. Puedes pasar datos al componente dinámico si es necesario
    // componentRef.instance.algunaPropiedad = this.algunaVariable;
    // componentRef.instance.algunEvento.subscribe((data) => { ... });

    // 5. Opcional: Ocultar el contenido actual de RdsTokenPingidComponent
    this.mostrarFuenteDinamica = true;
  }

  getMenu() {
    return this.menuService.getMenu().pipe(
      takeUntil(this.destroy$),
      tap((listMenu: any[]) => {
        console.log('listMenu3', listMenu);
        this.localStorageService.setDataMenu = listMenu['items'].map(el => new Menu().deserialize(el));
      }),
      switchMap(() => {
        const targetUrl = (this.region && this.domain && this.subDomain)
          ? `/rdsportal/data-maintenance/fuentes-rds/${this.region.toLocaleLowerCase()}/${this.domain.toLocaleLowerCase()}/${this.subDomain.toLocaleLowerCase()}`
          : environment.URL_RETURN_APP_RDS;
        console.log('Navegando a:', targetUrl);
        return this.router.navigateByUrl(targetUrl);
      }),
      catchError(err => {
        if (this.isUnauthorizedError(err)) {
          return this.handleUnauthorizedAndRedirect('Sesion invalida o expirada al cargar menu RDS', err);
        }
        console.error('Error en getMenu:', err);
        return of(null);
      })
    );
  }

  selectCountry(paisSelecionado: Country) {
    console.log('paisSelecionadoRDS', paisSelecionado);
    this.localStorageService.setRegionSeleccionada = paisSelecionado;
  }

  getListCountry(countriesLogin): Icountry[] {
    console.log('1countriesLogin', countriesLogin);
    let listCountry: Icountry[] = [];
    COUNTRIES.forEach((elemCountries: Icountry) => {
      console.log('1elemCountries', elemCountries);
      console.log('1elemCountries.code', elemCountries.code);
      const countryCode = (elemCountries?.code || '').toUpperCase();
      const countryLogin = countriesLogin.find((elementPaisLogin: any) => countryCode == elementPaisLogin.code.toUpperCase());
      console.log('1countryLogin', countryLogin);
      if (countryLogin) {
        console.log('2elemCountries', elemCountries);
        listCountry.push(elemCountries); // Simplemente agregamos el Icountry encontrado
      }
    });
    console.log('listCountry', listCountry);
    return listCountry;
  }

  get listCountry(): Icountry[] {
    return this.localStorageService?.getListCountries;
  }

  ngOnDestroy(): void {
    if (this.redirectTimeoutId !== null) {
      window.clearTimeout(this.redirectTimeoutId);
      this.redirectTimeoutId = null;
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

}
